import { render, staticRenderFns } from "./cost-center-self.vue?vue&type=template&id=0ccbdbbb&scoped=true&"
import script from "./cost-center-self.vue?vue&type=script&lang=js&"
export * from "./cost-center-self.vue?vue&type=script&lang=js&"
import style0 from "./cost-center-self.vue?vue&type=style&index=0&id=0ccbdbbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbdbbb",
  null
  
)

export default component.exports